import { Component, type ErrorInfo, type ReactNode } from 'react';
import * as Sentry from '@sentry/react';
import { Button } from '@alejandro3c/icy-react-ui';

interface Props {
	children: ReactNode;
}

interface State {
	hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
	state: State = { hasError: false };

	static getDerivedStateFromError(): State {
		return { hasError: true };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="flex flex-col items-center justify-center h-screen gap-4">
					<h1 className="text-2xl font-bold">Algo ha ido mal</h1>
					<p className="text-gray-600">Se ha producido un error inesperado.</p>
					<Button
						variant="solid"
						onClick={() => {
							this.setState({ hasError: false });
							window.location.href = '/';
						}}
					>
						Volver al inicio
					</Button>
				</div>
			);
		}

		return this.props.children;
	}
}
